import { styled } from '@mui/material/styles'

export const StyledPlusButton = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(-2.5)
}))

export const StyledPlusButtonDisabled = styled('div')(({ theme }) => ({
  color: theme.palette.secondary.main
}))

export const StyledConversionTextField = styled('div')({
  width: 200
})

export const StyledMarginTopArrow = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1.5)
}))

export const StyledMarginTop = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}))

export const StyledMarginBottom = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2)
}))
